/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {ActivationEnd, Router} from "@angular/router";
import {filter, map} from "rxjs";
import {RootScopeService} from "../../services/rootscope.service";
import {Steps} from "../../constant/steps";
import {RedirectionService} from "../../services/redirection.service";
import {Routes} from "../../constant/routes";
import {SharedService} from "../../services/shared.service";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {LangKeyService} from "../../services/lang-key.service";


@Component({
    selector: 'app-structure',
    templateUrl: './structure.component.html'
})
export class StructureComponent implements OnInit {

    // Translate
    currentLanguage = this.langKeyService.langKey;

    sessionId = '0';

    constructor(public rootScope: RootScopeService,
                private translate: TranslateService,
                private langKeyService: LangKeyService,
                private router: Router,
                private shared: SharedService,
                private redirectionService: RedirectionService) {
        console.log('init structure')
        // set the base language to browser language (will be use if it's not a session page with language overridden)
        if (navigator.language) {
            // navigator.language return something like fr-FR. We only need the first part
            this.langKeyService.setDefaultLocale(navigator.language.split(/-|_/)[0].toLowerCase())
            // apply the language
            this.langKeyService.setLocale(navigator.language.split(/-|_/)[0].toLowerCase())
        }
    }

    ngOnInit(): void {
        this.router.events.pipe(
            filter(e => e instanceof ActivationEnd),
            map(e => (e as ActivationEnd).snapshot)
        ).subscribe(snapshot => {
            // Translate
            if (snapshot.params['locale']) {
                if (snapshot.params['sessionId']) {
                    this.sessionId = snapshot.params['sessionId'];
                }
                this.updateLanguage(snapshot.params['locale']);
            }
            // Redirect to session if the page has been refreshed
            if (snapshot.routeConfig?.path?.includes(Routes.params.sessionId) && !this.router.url.includes('session/') && !this.rootScope.get().properties) {
                console.debug('Page refreshed. Redirect to session')
                this.redirectionService.sessionWithParams(snapshot.params, snapshot.params['sessionId'])
            }
        })
        // Step
        this.rootScope.get().isSmartphoneType = this.sessionType === 'smartphone';

        this.shared.on('add-custom-style', event => {
                console.info("new css", event)
                const head = document.getElementsByTagName('head')[0];
                if (document.querySelector('#customization')) {
                    head.removeChild(document.querySelector('#customization')!);
                }
                const style = document.createElement('style');
                style.type = 'text/css';
                style.id = "customization"
                style.appendChild(document.createTextNode(event.data.css));
                head.appendChild(style);
                this.ngOnInit();
            }
        );
    }

    // Nav
    languages = this.translate.getLangs();

    updateLanguage(lang: string) {
        console.debug('update language', lang, this.sessionId);
        this.currentLanguage = lang;
        //Add the sessionId in the translator loader in order to get specific override
        (this.translate.currentLoader as TranslateHttpLoader).suffix = '&sessionId=' + this.sessionId
        this.translate.use(lang);
        this.translate.getTranslation(lang);
    }

    // Step
    private sessionType = sessionStorage.getItem('sessionType');

    isActive(step) {
        return this.rootScope.get().step === step;
    };

    name(step) {
        for (var i in Steps) {
            if (Steps[i] === step) {
                return 'step.' + i;
            }
        }
        return '';
    };

    item(step) {
        return 'item' + step;
    };

    fraction() {

        switch (this.rootScope.get().steps.length) {
            case 2:
                return 'half';
            case 3:
                return 'third';
            case 4:
                return 'quarter';
            default:
                return 'quarter';
        }

    };

}
